<template>
    <div class="container" id="Home" v-title="'Home'">
        <Navigation-bar v-scrollShadow="false">
            <YD-select-project slot="title" :project-data="projectData" :show="roll > 100" :Id="projectId" @change="projectId = $event"></YD-select-project>
        </Navigation-bar>
        <Scroll 
            @scrollChange="roll = $event"
        >
            <div id="banner">
                <select v-model="userIndex">
                    <option :value="index" v-for="(item,index) in userArr" :key="index">{{item.u}}</option>
                </select>
                <button @click="goInfo()" v-pressed>我的</button>
                <button @click="tan()" v-pressed>弹窗</button>
                <button @click="tipShow = true">对话框1</button>
                <button @click="toPrompt">对话框2</button>
                <button @click="back()">back</button>
                <button v-href="'/Account/AccountSecurity'">账户安全</button>
                <button v-href="'/Account/CompanyManagement'">机构账户管理</button>
                <button v-href="'/Competition/EventCertificationList'">认证赛事列表</button>
                <button v-href="'/Competition/EventCertification'">申请认证</button>
                <button v-href="'/Competition/MyEventCertification'">我的认证赛事</button>
                <button v-href="'/Match/MatchList'">赛事广场</button>
                <button v-href="'/Integral/IntegralRanking'">积分排名</button>
                <button v-href="'/Integral/MyGrade'">我的成绩</button>
                <button v-href="'/Integral/MyIntegral'">我的积分</button>
                <button v-href="'/Rules/JoinUS'">系统介绍</button>
                <button v-href="'/Rules/CertificationAuthority'">认证机构</button>
                <button v-href="'/Rules/Membership'">申请入会</button>
                <button v-href="'/Rules/MemberList'">协会会员列表</button>
                <button v-href="'/Athletes/AthleteCertificationList'">运动员认证列表</button>
                <button v-href="'/Athletes/MyAttestationGrade'">个人我的评级</button>
                <button v-href="'/Athletes/MyApplyForAssessment'">机构我的评级申请</button>
                <button v-href="'/Athletes/AthleteCertification'">申请评定</button>
                <button v-href="'/PublicBenefits/DonateList'">爱心捐款</button>
                <button v-href="'/Account/AgencyRegistration?type=1'">机构账户注册</button>
                <button v-href="'/Account/IdentityAuthentication'">身份认证</button>
                <button v-href="'/Account/Information'">账号基本信息</button>
                <button v-href="'/Account/MySuperior'">我的单位/上级单位</button>
                <button v-href="'/Rules/PrivacyAgreement'">隐私协议</button>
                <button v-href="'/Rules/UserAgreement'">用户协议</button>
                <button v-href="'/Rules/HelpCenter'">帮助中心</button>
                <button v-href="'/Rules/ContactUs'">联系我们</button>
                <button v-href="'/Association'">中企体协</button>
                <button v-href="'/Enroll/EnrollRecord'">我的报名</button>
                <button v-href="'/MasterScore/Home'">掼蛋大师</button>
                <button v-href="'/MasterScore/MyGrade'">我的大师等级</button>
                <button v-href="'/Integral/HonorCertificates?url=http://pic.ntimg.cn/file/20181229/24935115_102835339000_2.jpg'">获奖证书</button>
                <button v-href="'/Enroll/OneselfEnroll/UpdatePersonnel'">个人报名</button>
                <button v-href="'/RefereeCoach/RefereeListHome'">裁判中心</button>
                <button v-href="'/RefereeCoach/CoachListHome'">教练中心</button>
                <button @click="dialog">dialog</button>
                <button v-href="'/News/Home'">新闻</button>
                <button v-href="'/Training/TrainingDetail/221'">培训详情</button>
                <button @click="goTest()">测试</button>
                <button v-href="'/Competition/BidEvent?serialId=1&from=banner'">系列赛</button>
                <button v-href="'/SerialMatch/MatchHome/1'">系列赛赛事</button>
                <button v-href="'/Match/GroupQRCode?leagueId=380'">群二维码</button>
                <button @click="selectDatetime">时间选择器</button>
            </div>
            <YD-category title="基本资料">
                <YD-fold label="1.赛事赛事赛事" :text="value" style="width:6.7rem" @unfoldChange="unfoldChange">
                    <YD-input v-model="value" label-hint="输入赛事" error-hint="请输入赛事" placeholder="请输入" @blur="tipShow = true"></YD-input>
                </YD-fold>
                <YD-fold label="2.赛事赛事赛事" :text="list[listIndex]" style="width:6.7rem"  @unfoldChange="unfoldChange">
                    <YD-select>
                        <YD-option v-for="(item,index) in list" :key="index"
                            line-number="2"
                            :active="index == listIndex"
                            @click.native="listIndex = index"
                        >{{item}}</YD-option>
                    </YD-select>
                </YD-fold>
            </YD-category>
            <YD-category title="基本资料22">
                <YD-fold label="1.赛事赛事赛事" :text="value" style="width:6.7rem" @unfoldChange="unfoldChange">
                    <YD-input v-model="value" label-hint="输入赛事" error-hint="请输入赛事"></YD-input>
                </YD-fold>
                <YD-fold label="2.赛事赛事赛事" :text="list[listIndex]" style="width:6.7rem"  @unfoldChange="unfoldChange">
                    <YD-select>
                        <YD-option v-for="(item,index) in list" :key="index"
                            line-number="2"
                            :active="index == listIndex"
                            @click.native="listIndex = index"
                        >{{item}}</YD-option>
                    </YD-select>
                </YD-fold>
            </YD-category>
            <input type="text" ref="input"/>
            <div class="div">{{text}}</div>
            <div id="nav" v-html="fileInfo"></div>
            <div id="list">{{appdata}}</div>
            <!-- <embed width="100%" height="100%" src="http://192.168.1.16:8080/files/界面说明样书_阶段二_申请认证.pdf"></embed> -->
            <!-- <iframe width="100%" height="100%" frameborder="0" src="http://192.168.1.16:8080/files/界面说明样书_阶段二_申请认证.pdf"></iframe> -->
            <div style="width:100%;height:100%" id="pdf"></div>
            <div id="echarts" ref="echarts"></div>
        </Scroll>
        <Alert-tip :tipData="alertTip" :tipShow="tipShow" @closeCallback="tipShow = false"  @btnCallback="btnCallback"></Alert-tip>
        <!-- <YD-dialog :show.sync="dialogShow">
            <div id="flow_chart">
                <h4>认证流程指引</h4>
                <ul>
                    <li>
                        <p><span>提交初审资料</span><YD-image src="icon/认证流程指引_标签_用户"></YD-image></p>
                        <p>比赛开始前，填写并提交赛事真实信息及资料</p>
                        <YD-image class="num" src="icon/认证流程指引_序号一"></YD-image>
                    </li>
                    <li>
                        <p><span>初审级别评定</span><YD-image src="icon/认证流程指引_标签_平台"></YD-image></p>
                        <p>根据您填写及提交的信息依照赛事管理办法进行初审评定级别</p>
                    </li>
                    <li>
                        <p><span>提交复审资料</span><YD-image src="icon/认证流程指引_标签_用户"></YD-image></p>
                        <p>比赛结束后，提交比赛相关的真实资料进行复审</p>
                        <YD-image class="num" src="icon/认证流程指引_序号二"></YD-image>
                    </li>
                    <li>
                        <p><span>复审定级发证</span><YD-image src="icon/认证流程指引_标签_平台"></YD-image></p>
                        <p>根据初审及复审资料依照赛事管理办法进行赛事级别评定</p>
                    </li>
                </ul>
                <button v-href="'/Competition/EventCertification'">我知道了</button>
            </div>
        </YD-dialog> -->
        <Datetime-picker type="datetime" value="2024-9-10 12:00" min="2024-9-8" ref="DatetimePicker" @change="pickerChange"></Datetime-picker>
        <!-- <Datetime-picker type="date" value="2024-9-10" min="2024-9-8" ref="DatetimePicker" @change="pickerChange"></Datetime-picker> -->
        <!-- <Datetime-picker type="time" value="12:10:12" min="11:58:00" ref="DatetimePicker" @change="pickerChange"></Datetime-picker> -->
        <!-- <Datetime-picker type="date-year" value="2024" min="2000" ref="DatetimePicker" @change="pickerChange"></Datetime-picker> -->
        <!-- <Datetime-picker type="date-month" value="2024-10" min="2020-1" ref="DatetimePicker" @change="pickerChange"></Datetime-picker> -->
        <!-- <Datetime-picker type="date-year" range :value="" min="2024" ref="DatetimePicker" @change="pickerChange"></Datetime-picker> -->
        <!-- <Datetime-picker type="date" range min="2024-9-1" ref="DatetimePicker" @change="pickerChange"></Datetime-picker> -->
        <svg v-pre style="display: none;">
            <defs>
                <filter id="filter">
                    <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur" />
                    <feColorMatrix
                        in="blur"
                        type="matrix"
                        values="1 0 0 0 0
                                0 1 0 0 0
                                0 0 1 0 0
                                0 0 0 20 -10" />
                </filter>
            </defs>
        </svg>
    </div>
</template>
<script>
import $ from 'jquery'
import { 
    LoginByPassword,
    SwitchToCompany,
    GetLayeredEventsListOnlyHasSubLeagues
} from "@/api"
import { backPage } from "@js/appInteraction"
import Pdfh5 from 'pdfh5';
import "pdfh5/css/pdfh5.css"
import Vue from 'vue';
import {
    Category,
    Fold,
    Input,
    Select,
    Option
} from '@/components/form';
// import Dialog from '@/components/Dialog';
import SelectProject from '@/components/SelectProject';
Vue.use(Category);
Vue.use(Fold);
Vue.use(Input);
Vue.use(Select);
Vue.use(Option);
// Vue.use(Dialog);
Vue.use(SelectProject);
import DatetimePicker from '@/components/datetime-picker/main.vue';
export default {
    name:"Home",
    components: {
        DatetimePicker
    },
    data(){
        return {
            roll: 0,
            value:'2222222',
            list:['aaa','bbb','ccc'],
            listIndex:0,
            alertTip:{
                title:"账户审核中",
                text:"请耐心等待，机构管理页可查看审核状态",
                btnArr:["取消","去查看"]
            },
            tipShow:false,
            appdata:"",
            fileInfo:"",
            files:{},
            userIndex:0,
            userArr : [{
                u:'0',
                p:'0'
            },{
                u:'17611009830',
                p:'123456',
                id:579
            },{
                u:'16601506762',
                p:'123456'
            },{
                u:'13525969176',
                p:'123456',
            },{
                u:'13699291739',
                p:'123456'
            },{
                u:"13699291990",
                p:"123456"
            },{
                u:'18611801099',
                p:'123456',
                // id:12
            },{
                u:'15243370526',
                p:'lwj123',
                // id:548
            },{
                u:'15243370501',
                p:'lwj123'
            },{
                u:'18612246404',
                p:'123456',
                id: 553
            }],
            text:0,
            dialogShow:false,
            projectId:0,
            projectData:[]
        }
    },
    created(){
        // this.$Toast('','loading');
        this.appdata = JSON.stringify(process.env);
        console.log(process.env.VUE_APP_PUBLIC_URL+'/')
        // location.href = process.env.VUE_APP_PUBLIC_URL+'/files/中国企业体育协会会员申请书.docx';
        // this.$navigation.go('/Rules/OnlinePreview?file_url='+process.env.VUE_APP_PUBLIC_URL+'/files/中国企业体育协会会员申请书.docx')
        console.log($vm)
        // backPage().then(()=>{
        //     console.log(22222222222)
        // })
        $.ajax({
            url: '/管理办法/11人制足球.html?v=202205111405',
            header:{
                "Content-Type":"text/html; charset=utf-8",
                "Accept-Language":"zh-CN"
            }
        })
        if(0){
            let aaa = '1';
            console.log(aaa);
        }else {
            let aaa = '2';
            console.log(aaa);
        }
        
        GetLayeredEventsListOnlyHasSubLeagues().then(data=>{
            if(data.Code == 0){
                var arr = data.EventsList;
                arr.unshift({Id:0,Name:'全部项目'});
                this.projectData = arr;
            }
        })
    },
    mounted(){
        // var oForm =  document.getElementsByTagName("form")[0];
        // oForm.onsubmit = function(){
        //     alert(1111111111)
        // };
        var _this = this;
        window.onkeyup=function(e){
            console.log(e);
            var e = e || event;
            if(e.keyCode == 13){
                _this.text = "22222222222222222";
                _this.$refs['input'].blur();
            }
            return false;
        }
        // this.pdfh5 = new Pdfh5("#pdf",{
        //     pdfurl: "http://192.168.1.16:8080/files/《职工体育》2022年第五期.pdf"
        // })
        // this.pdfh5.on("complete", function (status, msg, time) {
        //     console.log("状态：" + status + "，信息：" + msg + "，耗时：" + time + "毫秒，总页数：" + this.totalNum)
        // })
        
    },
    watch:{
        roll(scroll){
        },
        userIndex:{
            immediate:true,
            handler:function(index){
                localStorage.setItem('UserType',0);
                var userObj = this.userArr[index];
                if(userObj.u == 0) return;
                LoginByPassword({
                    "MobileNumber": userObj.u,
                    "_InputPassword": userObj.p
                }).then(data=>{
                    if(data.Code === 0){
                        this.$store.commit("setToken",data.SessionToken.AccessToken);
                        localStorage.setItem('UserType',data.SessionToken.UserType);
                        if(!userObj.id) return;
                        SwitchToCompany({
                            LoginCompanyId: userObj.id
                        }).then(data1=>{
                            if(data1.Code === 0){
                                this.$store.commit("setToken",data1.SessionToken.AccessToken);
                                localStorage.setItem('UserType',data1.SessionToken.UserType);
                            }
                        })
                    }
                })
            }
        },
        'alertTip.title':function(){

        },
        value:function(){
            console.log(222222222);
        }
    },
    methods:{
        selectDatetime(){
            this.$refs.DatetimePicker.show();
        },
        pickerChange(value, values){
            console.log(value, values);
        },
        goTest(){
            this.$router.push({path: '/appTest?a=1',meta: {aaa: 222222}})
        },
        toPrompt(){
            this.$Prompt({
                title: "温馨提示",
                message: "将删除用户",
                showCancel: true
            }).then(confirm=>{
                console.log(confirm)
            })
        },
        unfoldChange(a,b){
            console.log(a,b);
        },
        goInfo(){
        },
        back(){
            this.$navigation.back();
            alert(history.length)
        },
        tan(){
            this.$Toast({text:"服务器错误,服务器",position:"bottom"})
            this.$Toast("验证码错误验证码错误验证码错误验证码错误验证码错误验证码错误验证码错误验证码错误验证码错误验证码错误","error");
        },
        btnCallback(text){
            if(text == "取消"){
                this.tipShow = false;
            }
        },
        dialog(){
            this.dialogShow = true;
        },
        scrollChange(e,scroll){
            console.log(e,scroll);
        }
    }
}

</script>

<style scoped lang="scss">
#echarts{
    width: 100%;
    height: 500px;
}
#Home{
    height: 100%;
    overflow: hidden;
    position: relative;
}
.div{
    width: 144px;
    height: 112px;
    background: $default-bg;
    border: 1px solid rgba(245,245,245,1);
    box-shadow: 0px 6px 26px 0px rgba(23,71,128,0.1);
    // border-radius: 20px;
    margin: 100px;
    
}
#banner{
    width: 750px;
    min-height: 600px;
    position: relative;
    select{
        width: 670px;
        height: 112px;
        background: #F5F7F5;
        border-radius: 20px;
        padding: 0 32px;
        font-size: 32px;
        box-sizing: border;
        display: block;
        margin: 0 auto;
    }
}
#banner button{
    $br:20px;
    width: 350px;
    height: 92px;
    background: #7AD21A;
    box-shadow: 0px 10px 20px 0px rgba(9,144,22,0.25);
    border-radius: $br;
    color: #fff;
    font-size: 32px;
    text-align: center;
    font-weight: 500;
    @include btn-state($br);
    margin: 12px;
    // filter: url(#filter);
    
}
#nav{
    width: 750px;
    height: 100px;
}
#list{
    width: 100%;
    height: 200px;
    overflow: auto;
}
.selectFile{
    font-size: 30px;
}
.files img{
    width: 200px;
    height: auto;
}
#flow_chart{
    padding-top: 68px;
    h4{
        @include line-height(44px);
        padding-left: 40px;
        font-size: 32px;
        color: #1B1C1E;
        font-weight: 500;
        margin-bottom: 56px;
    }
    ul{
        overflow-y: auto;
        li{
            width: 100%;
            padding: 0 40px 0 104px;
            box-sizing: border-box;
            margin-bottom: 56px;
            position: relative;
            p:nth-of-type(1){
                height: 40px;
                width: 100%;
                font-size: 32px;
                color: #1B1C1E;
                line-height: 40px;
                font-weight: 500;
                display: flex;
                align-items: center;
                img{
                    width: 72px;
                    height: 34px;
                    margin-left: 8px;
                }
            }
            p:nth-of-type(2){
                font-size: 26px;
                color: #4D5561;
                line-height: 44px;
                font-weight: 400;
                margin-top: 16px;
            }
            >img{
                height: 56px;
                width: 56px;
                position: absolute;
                top: 0;
                left: 28px;
            }
        }
    }
    button{
        width: 296px;
        @include line-height(108px);
        background: #1B1C1E;
        box-shadow: 0px 10px 20px 0px rgba(27,28,30,0.25);
        border-radius: 54px;
        font-size: 32px;
        color: #FFFFFF;
        letter-spacing: 6px;
        font-weight: 500;
        display: block;
        margin: 0 auto;
        margin-top: 24px;
    }
}
</style>
